/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationsControllerFindOneQueryResponse, WorkflowApplicationsControllerFindOnePathParams, WorkflowApplicationsControllerFindOneQueryParams, WorkflowApplicationsControllerFindOne400, WorkflowApplicationsControllerFindOne401, WorkflowApplicationsControllerFindOne403, WorkflowApplicationsControllerFindOne404 } from "../../models/workflowsController/WorkflowApplicationsControllerFindOne";

function getWorkflowApplicationsControllerFindOneUrl(id: WorkflowApplicationsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/workflow-applications/${id}` as const }  
  return res
}

/**
 * @summary Get a workflow application by id
 * {@link /api/v1/workflow-applications/:id}
 */
export async function workflowApplicationsControllerFindOne(id: WorkflowApplicationsControllerFindOnePathParams["id"], params?: WorkflowApplicationsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<WorkflowApplicationsControllerFindOneQueryResponse, ResponseErrorConfig<WorkflowApplicationsControllerFindOne400 | WorkflowApplicationsControllerFindOne401 | WorkflowApplicationsControllerFindOne403 | WorkflowApplicationsControllerFindOne404>, unknown>({ method : "GET", url : getWorkflowApplicationsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}